import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ApiError } from "go-core/api/types";
import { CustomValidationError } from "go-form/services/types";
import { OrderPaymentMethodApi, PayOrderData } from "../../../../../../../services/Api/Public/types";
import OrderPaymentSectionHeader from "./OrderPaymentSectionHeader";
import OrderPayments from "./Payments/OrderPayments";

interface Props {
	setSelectedPaymentMethod: React.Dispatch<React.SetStateAction<OrderPaymentMethodApi | undefined>>;
	selectedPaymentMethod: OrderPaymentMethodApi | undefined;
	form: UseFormReturn<PayOrderData>;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<PayOrderData>[]>>;
	setSendInvoice: React.Dispatch<React.SetStateAction<boolean>>;
	sendInvoice: boolean;
	customFormErrors: ApiError[];
}

const OrderPaymentSection = ({
	setSelectedPaymentMethod,
	selectedPaymentMethod,
	form,
	setErrors,
	sendInvoice,
	setSendInvoice,
	customFormErrors,
}: Props) => {
	return (
		<>
			<OrderPaymentSectionHeader />
			<OrderPayments
				setSelectedPaymentMethod={setSelectedPaymentMethod}
				selectedPaymentMethod={selectedPaymentMethod}
				form={form}
				setErrors={setErrors}
				setSendInvoice={setSendInvoice}
				sendInvoice={sendInvoice}
				customFormErrors={customFormErrors}
			/>
		</>
	);
};

export default OrderPaymentSection;
